import { render, staticRenderFns } from "./RecommendedProducts.vue?vue&type=template&id=76253ac3&scoped=true&"
import script from "./RecommendedProducts.vue?vue&type=script&lang=js&"
export * from "./RecommendedProducts.vue?vue&type=script&lang=js&"
import style0 from "./RecommendedProducts.vue?vue&type=style&index=0&lang=css&"
import style1 from "./RecommendedProducts.vue?vue&type=style&index=1&id=76253ac3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76253ac3",
  null
  
)

component.options.__file = "RecommendedProducts.vue"
export default component.exports